<script setup lang="ts">
import { formatTime } from "@/common/time.common";
import { useTranslate } from "@/composables/use-translate";

const { t } = useTranslate();
</script>

<template>
  <v-card class="pt-8 pb-4 rounded-0 bg-black" variant="flat" dark>
    <v-container
      style="max-width: 90rem"
      class="text-center text-grey-lighten-2"
    >
      <img src="/assets/logo_taalblobs.png" alt="" class="mb-4" />
      <v-divider class="mb-4" />
      <v-row>
        <v-col cols="12" sm="6" md="4">
          <p>Ontwikkeld door: Ctrl Learning</p>
          <p>kvk: 87971690</p>
          <p>btw-nr: NL864463601B01</p>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <p>Verkoop en support: Woordhelder</p>
          <p>Onderwijsboulevard 418, 5223 DP 's-Hertogenbosch</p>
          <p>
            <a
              :href="`mailto:info@taalblobs.${t('extension')}`"
              style="color: inherit"
            >
              info@taalblobs.{{ t("extension") }}
            </a>
          </p>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <p>
            <a
              href="https://woordhelder.nl/privacy-statement"
              target="_blank"
              style="color: inherit"
            >
              Privacy policy
            </a>
          </p>
          <p>
            <a
              href="https://woordhelder.nl/info/algemene-voorwaarden"
              target="_blank"
              style="color: inherit"
            >
              Algemene voorwaarden
            </a>
          </p>
          <p>
            <a
              :href="`https://www.taalblobs.${t('extension')}/opzeggen`"
              target="_blank"
              style="color: inherit"
            >
              Opzeg voorwaarden
            </a>
          </p>
        </v-col>
      </v-row>
      <v-divider class="my-6" />
      <p class="ma-0 text-center">
        Copyright &copy; {{ formatTime(Date.now(), { year: "numeric" }) }}. Alle
        rechten voorbehouden
      </p>
    </v-container>
  </v-card>
</template>
